/**
 * Formata uma data no formato YYYY-MM-DD para DD/MM/YY
 * @param {string} dateString - Data no formato YYYY-MM-DD
 * @returns {string} - Data formatada no formato DD/MM/YY
 */
export function formatDateBR(dateString) {
  if (!dateString) return '-';
  
  // Se já estiver no formato DD/MM/YYYY ou DD/MM/YY, retorna como está
  if (dateString.includes('/')) return dateString;
  
  const [year, month, day] = dateString.split('-');
  const shortYear = year.slice(-2); // Pega apenas os 2 últimos dígitos do ano
  return `${day}/${month}/${shortYear}`;
}

/**
 * Formata uma data no formato YYYY-MM-DD para DD/MM/YYYY (ano completo)
 * @param {string} dateString - Data no formato YYYY-MM-DD
 * @returns {string} - Data formatada no formato DD/MM/YYYY
 */
export function formatDateBRFull(dateString) {
  if (!dateString) return '-';
  
  // Se já estiver no formato DD/MM/YYYY, retorna como está
  if (dateString.includes('/')) return dateString;
  
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
}
